import { render, staticRenderFns } from "./CloudFrontTypeValueList.vue?vue&type=template&id=0f2aa142"
import script from "./CloudFrontTypeValueList.vue?vue&type=script&lang=js"
export * from "./CloudFrontTypeValueList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports